import axios from 'axios'
// App Imports
import { API_URL } from '../../../../setup/config/env'

// Actions

// Create 
export function createOrUpdate(crm) {
  return dispatch => {
    return axios.post(API_URL+"/api/crm/createOrUpdate", {...crm})
  }
}

export function updateLeadStatus({ contactId, LeadStatus }) {
    return axios.post(API_URL + "/api/crm/updateLeadStatus", {
      contactId,
      LeadStatus,
    });
}

// update
export function updateGoal(crm) {
  return dispatch => {
    return axios.post(API_URL+"/api/crm/update", {...crm})
  }
}
//delete
export function remove({ contactId }) {
  return axios.post(API_URL+"/api/crm/delete", { contactId })
}

export const downloadYelpData = (data) => {
    const headers = {
        'Origin': window.location.origin,
        'Content-Type': 'application/json'
    };
    return axios.post(API_URL + "/api/crm/yelp/download", {
      businesses: data.businesses,
      location: data.location,
      term: data.term,
      isComplete: data.isComplete,
    },{headers});
};

export const saveContact = (data) => {
  return axios.post(API_URL + "/api/crm/saveContact", {data})
}

export const createClusterAndProject = (data) => {
  return axios.post(API_URL + "/api/crm/createClusterAndProject", data);
};

export const saveSampleData = (data) => {
  return axios.post(API_URL + "/api/crm/saveSampleData", data);
};

export const updateSettings = (data) => {
  return axios.post(API_URL + "/api/crm/updateSettings", data);
};

export const  listprojectsAndCluster = (orgId) => {
  return axios.post(API_URL + "/api/crm/listProjectsAndCluster", orgId)
}
export const listAtlasProfiles = () => {
  return axios.get(`${API_URL}/api/crm/listAtlasProfiles`);
};
export const listAtlasOrganizations = (profile) => {
  return axios.post(`${API_URL}/api/crm/listAtlasOrganizations`, { profile });
};
export const createAtlasOrganization = (data) => {
  return axios.post(`${API_URL}/api/crm/createAtlasOrganization`, data);
};
export const getCollections = (data) => {
  return axios.post(API_URL + "/api/crm/getCollections", data);
};

export const saveImagePaths = (data) => {
  return axios.post(API_URL + "/api/crm/saveImagePaths", data);
};

export const updateIpAddress = (data) => {
  return axios.post(API_URL + "/api/crm/updateIp", data)
}
export const sendTemplate = (data) => {
  return axios.post(API_URL + '/api/campaign/templates/send', data)
}

export const createClientConfig = (data) => {
  return axios.post(API_URL + '/api/clientConfig/create', data)
}

export const updateClientConfig = (payload) => {
  return axios.put(
    `${API_URL}/api/clientConfig/update`,
    payload
  );
};

export const deleteClientConfig = (clientConfigId) => {
  return axios.post(API_URL + `/api/clientConfig/delete`, { _id: clientConfigId });
}

export function createPlanLimit(data) {
  return axios.post(`${API_URL}/api/planLimit/add`, data);
}

export function updatePlanLimit(id, data) {
  return axios.post(`${API_URL}/api/planLimit/edit/${id}`, data);
}

export function deletePlanLimit(id) {
  return axios.delete(`${API_URL}/api/planLimit/delete/${id}`);
}

export function createSaasPlan(data) {
  return axios.post(`${API_URL}/api/saasPlan/add`, data);
}

export function updateSaasPlan(id, data) {
  return axios.post(`${API_URL}/api/saasPlan/edit/${id}`, data);
}

export function deleteSaasPlan(id) {
  return axios.delete(`${API_URL}/api/saasPlan/delete/${id}`);
}

export function createPlanModule(data) {
  return axios.post(`${API_URL}/api/planModule/add`, data);
}

export function updatePlanModule(id, data) {
  return axios.post(`${API_URL}/api/planModule/edit/${id}`, data);
}

export function deletePlanModule(id) {
  return axios.delete(`${API_URL}/api/planModule/delete/${id}`);
}
export function saveSaasConfig(data) {
  return axios.post(`${API_URL}/api/saasConfig/save`, data)
}

export const registerOAuthClient = (clientId) => {
  return axios.post(API_URL + '/api/oauth/register', { clientId });
}

export const startClientScheduler = (clientConfigId) => {
  return axios.post(`${API_URL}/api/clientConfig/scheduler/start`, { _id: clientConfigId });
};

export const stopClientScheduler = (clientConfigId) => {
  return axios.post(`${API_URL}/api/clientConfig/scheduler/stop`, { _id: clientConfigId });
};

export const bulkUpdateContacts = (data) => {
  return axios.post(`${API_URL}/api/crm/bulkUpdate`, data);
};

export const bulkDeleteContacts = (data) => {
  return axios.post(`${API_URL}/api/crm/bulkDelete`, data);
};


